import { useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '@store';
import {
  useScroll,
  SecurityLocks as SecurityLocksList,
  PermissionEnum,
  PermissionDenied,
} from '@ui/src';
import { setTakeCount } from './store/slices/locks';
import { useLazyGetLocksQuery } from './store/services';
import {
  schema,
  columns,
  columnsLabels,
  filtersSchema,
} from './variables/locks';

import cn from './styles.module.css';

const SecurityLocks = () => {
  const scrollRef = useRef<HTMLDivElement | null>(null);

  const {
    security: {
      locks: { locks, pagination, takeCount },
    },
    userList: {
      users: { users },
    },
    administrationDictionaries: { activePermissions },
  } = useAppSelector((state) => state);

  const dispatch = useAppDispatch();

  const [getList, { isFetching, isLoading }] = useLazyGetLocksQuery();

  useScroll({
    element: scrollRef,
    requestInProgress: isFetching,
  });

  useEffect(() => {
    let title = 'Security Locks';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  useEffect(() => {
    if (scrollRef && scrollRef.current) {
      const { offsetHeight } = scrollRef.current;

      if (offsetHeight) {
        const take = offsetHeight / 58;

        dispatch(setTakeCount(Math.ceil(take + 3)));
      }
    }
  }, [scrollRef]);

  let content;

  if (!activePermissions?.includes(PermissionEnum.LOCKS_LIST)) {
    content = <PermissionDenied />;
  } else {
    content = (
      <>
        <SecurityLocksList
          locks={locks}
          pagination={pagination}
          takeCount={takeCount}
          users={users}
          schema={schema}
          getList={getList}
          filtersSchema={filtersSchema}
          isFetching={isFetching}
          isLoading={isLoading}
          columns={columns}
          columnsLabels={columnsLabels}
        />
        <Outlet />
      </>
    );
  }

  return (
    <div className={cn.securityLocksContent} ref={scrollRef}>
      {content}
    </div>
  );
};

export default SecurityLocks;
